import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import * as _ from 'lodash';

import { PACT, SACT, LACT } from './config';

import { SearchModel } from 'shared/search/search.model';
import { StatusModel } from 'shared/search/status.model';
import { updateActionStatuses } from 'utils/contextual-actions';
import { BrandService } from 'shared/brand/brand.service';
import { ProcessService } from 'shared/process/process.service';

@Component({
  moduleId: module.id,
  selector: 'fitments-contextual-action',
  template: '',
  styleUrls: ['contextual-action.component.scss'],
})
export class FitmentsContextualActionComponent {

  @Input() availableStatuses: Array<number> = [];
  @Input() selectedRows: Array<{}> = [];
  @Input() size: number = 0;
  @Input() allSelected: boolean = false;
  @Input() searchModel: SearchModel;
  @Input() statusModel: StatusModel;
  @Input() listFilters: Array<any> = [];

  @Input() selectedRowsSize: number;
  @Output() actionSelected = new EventEmitter();

  listActions = [
    LACT.ADD_TO_LIST,
    LACT.REMOVE_FROM_LIST,
  ];


  get selectedRowsSizeText(): number|string {
    return this.allSelected ? `about ${this.selectedRowsSize}` : this.selectedRowsSize;
  }

  // handlers:
  onSelectedChange(action: any) {
    this.actionSelected.emit(action);
  }

  onAddToListClick() {
    this.actionSelected.emit(this.listActions[0]);
  }
}
